<form [formGroup]="editDivisionDetailForm">
    <div class="f-row custom-dialog">
        <div class="container">
            <div class="verify-title">
                <div class="title">
                    <h3 class="title-text">Edit Division Detail</h3>
                </div>
                <div class="close">
                    <button mat-icon-button (click)="onCancel()">
                        <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
                    </button>
                </div>
            </div>

            <div class="f-col verify-body">
                <div class="f-row">
                    <mat-form-field>
                        <mat-label>Name of Division</mat-label>
                        <input matInput formControlName="division" (keypress)="blockInvalidCharacters1($event)" (paste)="onPasteBlocked($event)"
                        (contextmenu)="disableRightClick($event)"/>
                        <mat-error *ngIf="editDivisionDetailForm.get('division')?.hasError('duplicate')">
                            This Division name aready exists.
                        </mat-error>
                    </mat-form-field>
                </div>
                <br />
                <div class="f-row pd-border-style">
                    <div class="f-col">
                        <div class="f-row validation-col">
                            <label class="mat-label">Status:</label>
                            <mat-radio-group aria-label="Select an option" formControlName="status">
                                <mat-radio-button [value]="true">{{ manageCompanyContent?.['b2b.managecompany.active'] }}</mat-radio-button>
                                <mat-radio-button [value]="false">{{ manageCompanyContent?.['b2b.managecompany.deactivate'] }}</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </div>
            </div>

            <div class="f-col d-align-right verify-footer">
                <button mat-button class="button--primary-small" (click)="onSave()">{{ content?.['b2b.booking.save'] }}</button>
            </div>
        </div>
    </div>
</form>